import { Field, Form, Formik } from "formik";
import React from "react";
import { toast } from "react-toastify";
import { addEventChatComment } from "../../../app/firestore/firebaseService";
import * as Yup from "yup";
import { Spinner } from "@chakra-ui/spinner";
import { Textarea } from "@chakra-ui/textarea";

export default function EventDetailedChatForm({
  eventId,
  parentId,
  closeForm,
}) {
  return (
    <Formik
      initialValues={{ comment: "" }}
      validationSchema={Yup.object({
        comment: Yup.string().required(),
      })}
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        try {
          await addEventChatComment(eventId, { ...values, parentId });
          resetForm();
        } catch (error) {
          toast.error(error.message);
        } finally {
          setSubmitting(false);
          closeForm({ open: false, commentId: null });
        }
      }}
    >
      {({ isSubmitting, handleSubmit, isValid }) => (
        <Form>
          <Field name='comment'>
            {({ field }) => (
              <div style={{ position: "relative" }}>
                <Textarea
                  rows='2'
                  variant='outline'
                  {...field}
                  placeholder='Enter Your Comment (Enter To Submit, SHIFT + ENTER for new line)'
                  onKeyPress={(e) => {
                    if (e.key === "Enter" && e.shiftKey) {
                      return;
                    }
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      isValid && handleSubmit();
                    }
                  }}
                ></Textarea>
                {isSubmitting && <Spinner />}
              </div>
            )}
          </Field>
        </Form>
      )}
    </Formik>
  );
}
